import { Navigate, Outlet } from 'react-router-dom'

import skipOnboardingLoader from '@app-studio-web/ui/loaders/skipOnboardingLoader'
import navigateToNextOnboardingPageAction from '../../actions/navigateToNextOnboardingPageAction'
import CautionLevelPage from './CautionLevel'
import CompleteSentencePage from './CompleteSentence'
import DatingMoodPage from './DatingMood'
import MessageValuesPage from './MessageValues'
import OpenerPage from './Opener'
import RedFlagsPage from './RedFlags'
import ReplyBehaviorPage from './ReplyBehavior'
import ReplySpeedPage from './ReplySpeed'
import SyncedPage from './SyncedPage'
import TipsPage from './Tips'
import UsuallySoundPage from './UsuallySound'
import VibePage from './Vibe'

const onboardingRoutes = [
  {
    path: '/onboarding',
    element: <Outlet />,
    loader: skipOnboardingLoader,
    children: [
      {
        element: <Navigate to="usually-sound" replace />,
        index: true,
      },

      {
        action: navigateToNextOnboardingPageAction,
        element: <UsuallySoundPage />,
        path: 'usually-sound',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <CautionLevelPage />,
        path: 'caution-level',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <RedFlagsPage />,
        path: 'red-flags',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <VibePage />,
        path: 'vibe',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <OpenerPage />,
        path: 'opener',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <MessageValuesPage />,
        path: 'message-values',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <TipsPage />,
        path: 'tips',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <ReplyBehaviorPage />,
        path: 'reply-behavior',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <ReplySpeedPage />,
        path: 'reply-speed',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <DatingMoodPage />,
        path: 'dating-mood',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <CompleteSentencePage />,
        path: 'complete-sentence',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <SyncedPage />,
        path: 'synced',
      },
    ],
  },
]

export default onboardingRoutes
